/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';

import pageTitles from 'helpers/page-titles';
import Logo from 'assets/logo.png';
import NavMenu from 'layouts/Main/components/NavMenu';
import { topNavConfig, moreMenuConfig } from 'helpers/top-nav-config';

import TopNavBar from './components/TopNavBar';
import Notifications from './components/Notifications';
import ContactUs from './components/ContactUs';
import useGetParams from './components/ContactUs/hooks/useGetParams';

const AppBar = MuiAppBar;

export default function Main() {
  const [pageTitle, setPageTitle] = useState('');

  const { t } = useTranslation('global');

  const theme = useTheme();
  const navigate = useNavigate();
  const matches = useMediaQuery(theme.breakpoints.up('xs'));
  const getParams = useGetParams();

  const currentPath = useLocation().pathname;

  useEffect(() => {
    const currentTitle = pageTitles.find((item) =>
      currentPath.includes(item.path)
    );
    setPageTitle(currentTitle ? t(currentTitle.title) : '');
  }, [currentPath, t]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />

      {/* AppBar superior con todo integrado en una sola línea */}
      <AppBar
        position="fixed"
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 2 }}
      >
        <Toolbar
          sx={{
            backgroundColor: 'white',
            '&.MuiToolbar-root': { paddingX: '10px' },
            minHeight: '64px',
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          {/* Logo */}
          <div
            onClick={() => navigate('/')}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              cursor: 'pointer',
              minWidth: '76px'
            }}
          >
            {/* <img
              alt="Gestión de Servicios"
              loading="lazy"
              src={Logo}
              width={76}
            /> */}
            <Typography
              color="inherit"
              sx={{ color: '#0E335C', fontSize: '10px', marginTop: '5px' }}
              variant="caption"
              noWrap
            >
              {t('general.serviceManagement')}
            </Typography>
          </div>

          {/* Título de página */}
          {matches && (
            <Tooltip title={pageTitle}>
              <Typography
                color="inherit"
                fontWeight={500}
                sx={{
                  color: '#0E335C',
                  fontSize: '20px',
                  display: '-webkit-box',
                  WebkitLineClamp: 1,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  minWidth: '150px',
                  fontVariant: 'small-caps',
                  marginLeft: '60px'
                }}
              >
                {pageTitle}
              </Typography>
            </Tooltip>
          )}

          {/* Menú de navegación integrado en la misma línea */}
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            <TopNavBar
              menuConfig={topNavConfig}
              moreMenuConfig={moreMenuConfig}
            />
          </Box>

          {/* Iconos de la derecha */}
          <ContactUs googleChatLink={getParams?.data?.data?.GoogleChat?.Link} />
          <Notifications />
          <NavMenu />
        </Toolbar>
      </AppBar>

      {/* Contenido principal */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          marginTop: '64px', // Solo una barra ahora
          display: 'flex',
          flexDirection: 'column',
          maxHeight: 'calc(100vh - 64px)',
          overflow: 'hidden',
          position: 'relative',
          '@media (max-width: 450px)': {
            padding: '10px',
            marginTop: '64px',
            marginBottom: '5px'
          }
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
